var styles = {
  "themeContainer": "Polaris-ThemeProvider--themeContainer"
};

export { styles as default };
